export default __webpack_public_path__ + "static/media/calender.0ea91dd7.mp4";